import React                                                    from 'react';
import { tabRout as tabToutTooltip, scoring as scoringTooltip } from 'pu-data/Tooltips';
import CheckboxComponent                                        from './CheckboxComponent';

const TabRoutScoring = props => (
  <div className="row">
    <div className="col-md-6">
      <CheckboxComponent
        name="tab_rout"
        label="Tab-Rou"
        tooltip={tabToutTooltip}
        checked={props.parameters.tab_rout === '1'}
        onChange={e => props.onChangeParameter('tab_rout', e.target.checked ? '1' : '0')}
        inputId="tab-route" />
    </div>
    <div className="col-md-6">
      <CheckboxComponent
        name="scoring"
        label="Scoring"
        tooltip={scoringTooltip}
        checked={props.parameters.scoring === '1'}
        onChange={e => props.onChangeParameter('scoring', e.target.checked ? '1' : '0')}
        inputId="scoring" />
    </div>
  </div>
);

TabRoutScoring.defaultProps = {
  type: 'checkbox',
};

export default TabRoutScoring;
